













































































import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlShiiresaki from '@/components/common/search/CtrlShiiresaki.vue';
import {
  OutStatus,
  ShiiresakiKb,
  UmuFlg,
  KaigaiKobetsuKb,
  Flg,
} from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import { dateStrToNum } from '@/utils/utils';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'G_060_ShukkaJunbi_BatchOrderEditing',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
    CtrlDatePicker,
    CtrlShiiresaki,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    junbiInfo: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    BUTTON,
    ShiiresakiKb,
    UmuFlg,
    Flg,
    KaigaiKobetsuKb,
    shukkaYoteiFlg: false,
    shukkaYoteiYmd: '',
    haisoKaishaFlg: false,
    haisoKaishaCd: 0,

    messageShow: false,
    messageId: '',
    messageTextParam: [],
    messageConfirm: false,
    messageConfirmClear: false,
    isReload: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
  },
  watch: {
    shukkaYoteiFlg() {
      this.shukkaYoteiYmd = '';
    },
    haisoKaishaFlg() {
      this.haisoKaishaCd = 0;
    },
  },
  methods: {
    hide(reload = true) {
      this.$emit('update:show', false);
      this.$emit('hide', reload);
    },
    handleCancelMessage() {
      this.messageConfirm = false;
      this.messageConfirmClear = false;
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      if (this.messageConfirm) {
        this.messageConfirm = false;
        this.handleSubmitUpdate();
        return;
      }
      if (this.messageConfirmClear) {
        this.messageConfirmClear = false;
        this.handleSubmitClear();
        return;
      }
      if (this.isReload) {
        this.isReload = false;
        this.hide(true);
      }
    },
    callbackOkShiiresaki(item: any) {
      if (item && item.shiiresakiCd) {
        this.haisoKaishaCd = +item.shiiresakiCd;
      } else {
        this.haisoKaishaCd = 0;
      }
    },
    async checkValidateClear() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();
      if (!this.shukkaYoteiFlg && !this.haisoKaishaFlg) {
        this.messageId = 'KI_W111';
        this.messageTextParam = ['一括更新項目未選択', 'クリア'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      this.messageId = 'KI_Q101';
      this.messageTextParam = ['一括でクリア'];
      this.messageConfirmClear = true;
      this.messageShow = true;
    },
    async checkValidateUpdate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();
      if (!this.shukkaYoteiFlg && !this.haisoKaishaFlg) {
        this.messageId = 'KI_W111';
        this.messageTextParam = ['一括更新項目未選択', '保存'];
        this.messageShow = true;
        return;
      }
      if (this.shukkaYoteiFlg && !this.shukkaYoteiYmd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['出荷予定日'];
        this.messageShow = true;
        return;
      }
      if (
        this.userInfo.kaigaiKobetsuKb !== KaigaiKobetsuKb.NICHIREI_LOGI &&
        this.haisoKaishaFlg &&
        !this.haisoKaishaCd
      ) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['配送会社'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      this.messageId = 'KI_Q101';
      this.messageTextParam = ['一括編集'];
      this.messageConfirm = true;
      this.messageShow = true;
    },
    async handleSubmitUpdate() {
      try {
        this.$store.dispatch('common/setIsLoading', true);
        const requestData = {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          updateInfo: {
            shukkaYoteiYmd: this.shukkaYoteiFlg
              ? dateStrToNum(this.shukkaYoteiYmd)
              : -1,
            haisoKaishaCd: this.haisoKaishaFlg ? +this.haisoKaishaCd : -1,
            clearFlg: Flg.FLG_FALSE,
          },
          junbiInfo: this.junbiInfo,
        };
        const res = await this.$store.dispatch('g060/putIkkatsu', requestData);
        this.$store.dispatch('common/setIsLoading', false);
        if (
          res &&
          res.status == 200 &&
          res.data &&
          res.data.error &&
          res.data.error.messageID &&
          res.data.error.outStatus &&
          res.data.error.outStatus != OutStatus.NORMAL
        ) {
          const { error } = res.data;
          if (error.outStatus == OutStatus.CHECK_ERR) {
            this.messageShow = true;
            this.messageId = error.messageID;
            this.messageTextParam = error.messageArgs;
            return;
          } else if (error.outStatus == OutStatus.EXCLUSIVE_ERR) {
            this.messageShow = true;
            this.messageId = error.messageID;
            this.messageTextParam = error.messageArgs;
            this.isReload = true;
            return;
          }
        }
        this.hide();
      } catch (error) {
        console.error(error);
      }
    },
    async handleSubmitClear() {
      try {
        this.$store.dispatch('common/setIsLoading', true);
        const requestData = {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          updateInfo: {
            shukkaYoteiYmd: this.shukkaYoteiFlg ? 0 : -1,
            haisoKaishaCd: this.haisoKaishaFlg ? 0 : -1,
            clearFlg: Flg.FLG_TRUE,
          },
          junbiInfo: this.junbiInfo,
        };
        const res = await this.$store.dispatch('g060/putIkkatsu', requestData);
        this.$store.dispatch('common/setIsLoading', false);
        if (
          res &&
          res.status == 200 &&
          res.data &&
          res.data.error &&
          res.data.error.messageID &&
          res.data.error.outStatus &&
          res.data.error.outStatus != OutStatus.NORMAL
        ) {
          const { error } = res.data;
          if (error.outStatus == OutStatus.CHECK_ERR) {
            this.messageShow = true;
            this.messageId = error.messageID;
            this.messageTextParam = error.messageArgs;
            return;
          } else if (error.outStatus == OutStatus.EXCLUSIVE_ERR) {
            this.messageShow = true;
            this.messageId = error.messageID;
            this.messageTextParam = error.messageArgs;
            this.isReload = true;
            return;
          }
        }
        this.hide();
      } catch (error) {
        console.error(error);
      }
    },
  },
});
